import { api as apiUtils } from '@bilibili-maoer/web-utils'

import { FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query'
import { BaseQueryFn, createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { match } from 'ts-pattern'

import { identity } from '~/core/utils/identity'
import { P } from '~/core/utils/p'
import { MilliSeconds } from '~/shared/types/base/units'

const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  {
    codes?: number[]
  },
  FetchBaseQueryMeta
> = async (args: string | FetchArgs, api, extraOptions = {}) => {
  const defaultMethod = {
    query: 'GET',
    mutation: 'POST',
  }[api.type]

  const objectArgs = typeof args === 'string' ? { url: args } : args

  objectArgs.method ??= defaultMethod

  const res = await fetchBaseQuery({
    baseUrl: `${apiUtils.MISSEVAN_FM_API_PREFIX_URL}/api`,
    mode: 'cors',
    credentials: 'include',
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    timeout: 60_000 as MilliSeconds,
    validateStatus(response, body) {
      return match(body)
        .with({ success: P.boolean }, ({ success }) => success)
        .with({ code: P.number }, ({ code }) => code === 0 || !!extraOptions.codes?.includes(code))
        .otherwise(() => response.ok)
    },
  })(objectArgs, api, extraOptions)

  if (extraOptions.codes) {
    return res
  }

  return match(res)
    .with(
      {
        data: {
          code: 0,
          info: P.any,
        },
      },
      (x) => ({
        ...x,
        data: x.data.info,
      })
    )
    .otherwise(identity)
}

export const FmApi = createApi({
  reducerPath: 'FmApi',
  baseQuery,
  tagTypes: ['MyGuild', 'AdminGuild', 'GuildReportMenu', 'GuildInvite', 'GuildIncomeMenu'],
  endpoints: () => ({}),
})
